/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { WorkPackageStatuses } from '../../constants/storyStatusTypes';
import { updateTargetStatus } from '../../actions/targetActions';
import { checkResultsToBeTransfered } from '../../utils/targetHelpers';

class DetailStatus extends React.Component {
  handleClick = event => {
    event.preventDefault();
    const newStatus = event.target.name;
    const { targetId, status, updateStatus } = this.props;

    if (
      (newStatus === WorkPackageStatuses.ACCEPTED ||
        newStatus === WorkPackageStatuses.LIVE) &&
      (status === WorkPackageStatuses.GETTING_READY ||
        status === WorkPackageStatuses.IN_PROGRESS)
    ) {
      const { target, targetWorkPackages } = this.props;

      checkResultsToBeTransfered(target, targetWorkPackages, newStatus);
    } else {
      updateStatus(targetId, newStatus);
    }
  };

  render() {
    const { status } = this.props;
    const disabled = !this.props.allowEdit;

    return (
      <div className="row">
        <div className="col-sm-3">
          <button
            type="button"
            name={WorkPackageStatuses.GETTING_READY}
            className={`status-btn ${
              status === WorkPackageStatuses.GETTING_READY
                ? 'getting-ready-active'
                : 'getting-ready-normal'
            }`}
            onClick={this.handleClick}
            disabled={disabled}
          >
            PLANNING
          </button>
        </div>
        <div className="col-sm-3">
          <button
            type="button"
            name={WorkPackageStatuses.IN_PROGRESS}
            className={`status-btn ${
              status === WorkPackageStatuses.IN_PROGRESS
                ? 'progress-active'
                : 'progress-normal'
            }`}
            onClick={this.handleClick}
            disabled={disabled}
          >
            IN PROGRESS
          </button>
        </div>
        <div className="col-sm-3">
          <button
            type="button"
            name={WorkPackageStatuses.ACCEPTED}
            className={`status-btn ${
              status === WorkPackageStatuses.ACCEPTED
                ? 'accepted-active'
                : 'accepted-normal'
            }`}
            onClick={this.handleClick}
            disabled={disabled}
          >
            DONE
          </button>
        </div>
        <div className="col-sm-3">
          <button
            type="button"
            name={WorkPackageStatuses.LIVE}
            className={`status-btn ${
              status === WorkPackageStatuses.LIVE
                ? 'live-active'
                : 'live-normal'
            }`}
            onClick={this.handleClick}
            disabled={disabled}
          >
            LIVE
          </button>
        </div>
      </div>
    );
  }
}

DetailStatus.propTypes = {
  statuses: PropTypes.string,
  targetId: PropTypes.number,
  allowEdit: PropTypes.bool
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      updateStatus: updateTargetStatus
    },
    dispatch
  );

export default connect(
  null,
  mapDispatchToProps
)(DetailStatus);
